// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"257":"0f4080db","453":"dedb7a9f","563":"18fc6c57"}[chunkId] + ".chunk.js";
};